export default __webpack_public_path__ + "static/media/man-typing-on-laptop.7cc2b648.svg";